export enum ParameterCod {
  Name = 'PARM.PUB.ORGANIZATION.NAME',
  City = 'PARM.PUB.ORGANIZATION.CITY',
  Department = 'PARM.PUB.ORGANIZATION.DEPARTMENT',
  Address = 'PARM.PUB.ORGANIZATION.ADDRESS',
  Phone = 'PARM.PUB.ORGANIZATION.PHONE',
  Slogan = 'PARM.PUB.ORGANIZATION.SLOGAN',
  Email = 'PARM.PUB.ORGANIZATION.EMAIL',
  IdentificationNumber = 'PARM.PUB.ORGANIZATION.IDENTIFICATION',
  Logo = 'PARM.PUB.ORGANIZATION.LOGO',
  Client = 'PARM.PUB.ORGANIZATION.CLIENT',
  TermsAndconditions = 'PARM.PUB.PRIVACY.TERMS_AND_CONDITIONS_URL',
  PersonalDataProcessingPolicy = 'PARM.PUB.PRIVACY.POLICY_URL',
  PqrsdfVisible = 'PARM.PUB.PQRSDF.VISIBLE',
  PqrsdfDefinitionKey = 'PARM.PUB.PQRSDF.DEFINITIONKEY',
  ProceduresVisible = 'PARM.PUB.DASHBOARD.TRAMITES.VISIBLE',
  TaxesVisible = 'PARM.PUB.DASHBOARD.TAXES.VISIBLE',
}

export type ParameterCodeEntry = {
  code: string;
  description: string;
};

export const parameterCodeGroups: Array<{
  title: string;
  description?: string;
  items: ParameterCodeEntry[];
}> = [
  {
    title: 'Organización',
    description: 'Parámetros generales de identidad y contacto de la entidad.',
    items: [
      {
        code: ParameterCod.Logo,
        description: 'Logo de la organización (favicon/header).',
      },
      {
        code: ParameterCod.Name,
        description: 'Nombre de la organización/entidad mostrado en la UI.',
      },
      {
        code: ParameterCod.IdentificationNumber,
        description: 'Identificación/NIT de la organización.',
      },
      {
        code: ParameterCod.Department,
        description: 'Departamento de la organización (ubicación).',
      },
      {
        code: ParameterCod.City,
        description: 'Ciudad/Municipio de la organización (ubicación).',
      },
      {
        code: ParameterCod.Address,
        description: 'Dirección física de la organización.',
      },
      {
        code: ParameterCod.Email,
        description: 'Correo de contacto público de la organización.',
      },
      {
        code: ParameterCod.Phone,
        description: 'Teléfono de contacto público de la organización.',
      },
      {
        code: ParameterCod.Slogan,
        description: 'Eslogan de la organización.',
      },
      {
        code: ParameterCod.Client,
        description: 'Cliente o nombre alternativo de la organización.',
      },
    ],
  },
  {
    title: 'Módulos y Visibilidad',
    description: 'Parámetros de visibilidad y definición para el módulo PQRSDF y Dashboard.',
    items: [
      {
        code: ParameterCod.PqrsdfVisible,
        description: 'Controla si el módulo PQRSDF se muestra/oculta en el público.',
      },
      {
        code: ParameterCod.PqrsdfDefinitionKey,
        description: 'DefinitionKey usado para el flujo/proceso de PQRSDF.',
      },
      {
        code: ParameterCod.ProceduresVisible,
        description: 'Controla si el módulo de Trámites se muestra en el dashboard.',
      },
      {
        code: ParameterCod.TaxesVisible,
        description: 'Controla si el módulo de Impuestos se muestra en el dashboard.',
      },
    ],
  },
  {
    title: 'Legal',
    description:
      'URL de los textos legales. Configurar páginas donde están los términos y privacidad.',
    items: [
      {
        code: ParameterCod.TermsAndconditions,
        description: 'URL de "Términos y condiciones".',
      },
      {
        code: ParameterCod.PersonalDataProcessingPolicy,
        description: 'URL de "Política de privacidad".',
      },
    ],
  },
];

export const parameterCodeCatalog: ParameterCodeEntry[] = parameterCodeGroups.flatMap(
  (group) => group.items
);
